import React, { useEffect, useState } from "react";
import { withImageResizer } from "lib/utils";
import ArrowRight from "../Icons/ArrowRight";
import ArrowLeft from "../Icons/ArrowLeft";
import DateIcon from "../Icons/DateIcon";
import LocationIcon from "../Icons/LocationIcon";
import TimeIcon from "../Icons/TimeIcon";
import ClockIcon from "../Icons/ClockIcon";
import { format } from "date-fns";
import Link from "next/link";

const MainBanner = ({ dataMainBanner }) => {
  const [items, setItems] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  const prevClick = () => {
    const newItems = [...items];
    newItems.unshift(newItems.pop());
    setItems(newItems);
  };

  const nextClick = () => {
    const [first, second, ...rest] = items;
    setItems([second, ...rest, first]);
  };

  const sliderControl = (isLeft) => {
    return (
      <button
        className="bg-black opacity-80 h-14 w-14 rounded-md flex
        justify-center items-center m-1
      "
        type="button"
        role="button"
        onClick={() => {
          isLeft ? prevClick() : nextClick();
        }}
      >
        <span role="img" aria-label={`Arrow ${isLeft ? "left" : "right"}`}>
          {isLeft ? (
            <ArrowLeft height={16} width={10} />
          ) : (
            <ArrowRight height={16} width={10} />
          )}
        </span>
      </button>
    );
  };

  useEffect(() => {
    if (dataMainBanner.length > 0) {
      setItems(dataMainBanner);
    }
  }, [dataMainBanner]);

  return (
    <section className="w-full bg-main bg-center bg-no-repeat bg-cover">
      <div className="w-full bg-gradient-to-t from-white to-transparent pt-36 desktopLarge:pt-28 laptop:pt-24 pb-4 phone-100:pb-20 phone:pb-10 phone:pt-16">
        <div className="flex items-start justify-center phone-100:flex-col phone-100:items-center">
          <div className="p-8 desktopExtraSmall:p-6 tablet:mb-0 phone-100:hidden max-w-[519px] w-full">
            {items?.[0]?.urlName && (
              <>
                <Link
                  href={`/?eventSlug=${items?.[0]?.urlName}&accountSlug=${items?.[0]?.account?.urlName}`}
                  as={`/kirkko/${items?.[0]?.account?.urlName}/${items?.[0]?.urlName}`}
                >
                  <a className="ml-auto w-full flex">
                    <div className="ml-auto bg-gray-100 rounded-20 relative w-full min-h-[712px] fullhd:min-h-[650px] desktopLarge:min-h-[600px] desktopMed:min-h-[500px] laptop:min-h-[400px] tablet-100:min-h-[338px]">
                      <img
                        alt={
                          "Etusivun korostettu tapahtuma" + items?.[0]?.title
                        }
                        className="h-auto rounded-20 object-cover shadow-bigItem bg-gray-100"
                        src={`${
                          items?.[0]?.previewImg
                            ? withImageResizer(items?.[0]?.previewImg, 640)
                            : "/images/bg1.jpeg"
                        }`}
                        style={{ minHeight: "inherit" }}
                      />

                      <div
                        className={
                          "absolute rounded-bl-20 max-w-md rounded-tr-20 bottom-0 left-0 backdrop-filter backdrop-blur-lg text-white bg-blackTransparent p-12 desktopMed:p-8 desktopExtraSmall:p-4 tablet-100:hidden"
                        }
                      >
                        <h2 className="font-bold text-bodyText desktopExtraSmall:text-base">
                          SUOSITTELEMME
                        </h2>
                        <div>
                          <h2 className="font-bold text-5xl mb-5 desktopExtraSmall:text-2xl">
                            {items?.[0]?.title}
                          </h2>
                          <div className="flex justify-between">
                            <div>
                              <p className="flex items-center">
                                <LocationIcon height={14.18} width={10.64} />
                                <span className="font-bold pl-2.5">
                                  {items?.[0]?.account.name}
                                </span>
                              </p>
                              <p className="flex items-center">
                                <ClockIcon height={13.85} width={13.85} />
                                <span className="font-bold pl-2.5  pr-2.5">
                                  {items?.[0]?.publishingDate &&
                                    format(
                                      new Date(items?.[0]?.publishingDate),
                                      "HH.mm"
                                    )}
                                </span>
                                <DateIcon height={14.98} width={13.1} />
                                <span className="font-bold pl-2.5">
                                  {items?.[0]?.publishingDate &&
                                    format(
                                      new Date(items?.[0]?.publishingDate),
                                      "dd.MM.yyyy"
                                    )}
                                </span>
                              </p>
                            </div>
                            <div className="rounded-5 bg-blue  flex justify-center items-center self-center mx-6  w-9 h-35  desktopExtraSmall:m-[5px]">
                              <div className="flex justify-center rounded bg-blue self-center text-lg font-bold text-white">
                                <ArrowRight height={10} width={6} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </Link>
                {items?.length > 1 && (
                  <div className="flex justify-end mt-4 tablet-100:hidden">
                    {sliderControl(true)} {sliderControl(false)}
                  </div>
                )}
              </>
            )}
          </div>
          <div className="p-8 desktopExtraSmall:p-6 tablet-100:flex-none text-left tablet:p-6 tablet:min-w-[400px] phone-100:text-center phone-100:order-1 phone:min-w-full">
            <div className="mb-[85px] fullhd:mb-[75px] desktopLarge:mb-[50px] laptop:mb-[30px] phone-100:mb-0">
              <h2 className="text-9.5xl leading-none mb-5 desktopLarge:text-8xl desktopMed:text-7xl laptop:text-xlHeader tablet-100:mb-2.5 phone:text-lheader phone:py-2 phone:text-5xl">
                Tervetuloa
              </h2>
              <p className="max-w-[40rem] text-bodyText desktopMed:text-base leading-normal desktopMed:text-lg tablet:m-auto tablet-100:max-w-lg phone:text-base">
                Ylimmäisenä sivustolla näkyvät suorat, tulevat ja menneet
                lähetykset.  Klikkaamalla haluamaasi kirkon kuvaa, pääset
                näkemään lähetykset kirkoittain.  Voit myös hakea tapahtumaa
                "etsi-valikosta" hakusanalla.
                <br />
                <br />
                Palaute ja yksityistilaisuuksien tiedustelut sähköpostilla:{" "}
                <a href="mailto:info@virtuaalikirkko.fi">
                  info@virtuaalikirkko.fi
                </a>
              </p>
            </div>
            <div className="tablet:hidden h-[320px]">
              <h3 className="text-xl font-medium mb-7 laptop:mb-5 laptop:text-lg">
                LISÄÄ SUOSITUKSIA
              </h3>
              <ul className="flex">
                {dataMainBanner &&
                  items.length > 0 &&
                  items.slice(1, 4).map((item) => (
                    <Link
                      key={item._id}
                      href={`/?eventSlug=${item?.urlName}&accountSlug=${item?.account?.urlName}`}
                      as={`/kirkko/${item?.account?.urlName}/${item?.urlName}`}
                    >
                      <a className="flex-1 max-w-[230px]">
                        <li className="group rounded-10 flex justify-start flex-col mx-2 bg-transparent transition-all duration-200 ease-linear delay hover:scale-110 hover:shadow-item hover:bg-white-100">
                          <img
                            alt="image"
                            className="rounded-10 min-h-[179px] max-w-full max-h-full max-h-frontBannerSmallImg object-cover min-w-mainBannerItem object-bottom transition-all duration-200 ease-linear delay group-hover:rounded-br-none group-hover:rounded-bl-none fullhd:min-h-[129px] bg-gray-100"
                            src={
                              item.previewImg
                                ? withImageResizer(item.previewImg, 640)
                                : "/images/bg1.jpeg"
                            }
                          />
                          <article className="rounded transition-all duration-200 ease-linear delay pt-2 group-hover:pl-4 desktopBannerItems:group-hover:pl-[10px]">
                            <h2 className="w-full">
                              <span className="font-bold inline-block transition-all duration-200 ease-linear delay text-bodyText origin-left group-hover:scale-[0.92] leading-[29px] truncate-text two-lines break-all">
                                {item.title}
                              </span>
                            </h2>
                            <div className="opacity-0 flex transition-all duration-200 ease-linear delay group-hover:opacity-100 justify-between pb-3">
                              <div className="text-xs justify-start">
                                <div className="flex flex-col">
                                  <div className="flex items-center">
                                    <LocationIcon />
                                    <span className="font-bold text-xxs text-gray pl-2.5">
                                      {item.account.name}
                                    </span>
                                  </div>
                                  <div className="flex items-center justify-between pt-0.5">
                                    <div className="flex items-center">
                                      <TimeIcon />
                                      <span className="font-bold text-xxs text-gray pl-2.5">
                                        {item.publishingDate &&
                                          format(
                                            new Date(item.publishingDate),
                                            "HH.mm"
                                          )}
                                      </span>
                                    </div>
                                    <div className="flex items-center px-2.5">
                                      <DateIcon />
                                      <span className="font-bold text-xxs text-gray pl-2.5">
                                        {item.publishingDate &&
                                          format(
                                            new Date(item.publishingDate),
                                            "dd.MM.yyyy"
                                          )}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="rounded-5 bg-blue flex justify-center items-center self-center mr-3 w-7 h-27 transition-all duration-200 ease-linear delay">
                                <div className="flex justify-center rounded bg-blue self-center text-lg font-bold text-white">
                                  <ArrowRight height={10.49} width={6.36} />
                                </div>
                              </div>
                            </div>
                          </article>
                        </li>
                      </a>
                    </Link>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MainBanner;
